module.exports = __webpack_public_path__ + "img/transfer.e155f1c6.svg";